// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-carousel/image-carousel.component.scss
// module id = 121
// module chunks = 0